import {
    mdiAccountCircleOutline,
    mdiMenuOpen,
    mdiMenuClose,
    mdiHomeSiloOutline,
    mdiTestTubeEmpty,
    mdiCogOutline,
    mdiAccountGroupOutline,
    mdiClipboardListOutline,
    mdiSitemapOutline,
    mdiPlus,
    mdiInformationVariantCircleOutline,
    mdiClipboardEditOutline,
    mdiAccountFilterOutline,
    mdiArrowLeft,
    mdiClipboardTextOutline,
    mdiTestTube,
    mdiFileDocumentPlusOutline,
    mdiEye,
    mdiEmail,
    mdiSend,
    mdiUpload,
    mdiDownload,
    mdiCloudUpload,
    mdiRefresh,
    mdiChevronDown,
    mdiChevronUp
  } from "@mdi/js";

export const account = mdiAccountCircleOutline;
export const menuOpen = mdiMenuOpen;
export const menuClose = mdiMenuClose;
export const farms = mdiHomeSiloOutline;
export const soilAnalysis = mdiTestTubeEmpty;
export const settings = mdiCogOutline;
export const users = mdiAccountGroupOutline;
export const tasks = mdiClipboardListOutline;
export const organisations = mdiSitemapOutline;
export const add = mdiPlus;
export const info = mdiInformationVariantCircleOutline;
export const reports = mdiClipboardEditOutline;
export const soilsamplers = mdiAccountFilterOutline;
export const back = mdiArrowLeft;
export const taskReports = mdiClipboardTextOutline;
export const soilAnalysisReports = mdiTestTube;
export const createReport = mdiRefresh;
export const viewReport = mdiEye;
export const emailReport = mdiSend;
export const uploadReport = mdiUpload;
export const downloadReport = mdiDownload;
export const ftpUpload = mdiCloudUpload;
export const regenerateReport = mdiRefresh;
export const chevronDown = mdiChevronDown;
export const chevronUp = mdiChevronUp;